import { object, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'
import withProps from 'recompose/withProps'

import interceptUpdater from 'coact-utils/interceptUpdater'

import HeadEditorView from './HeadEditor'


const HeadEditor = scope(
  consumeProps({
    value: object,
    onChange: func.isRequired,
  }),

  interceptUpdater('onChange', () => (value, oldValue) => {
    const {
      customerRef: customerRefOrigin,
      orderStafferRef: orderStafferRefOrigin,
      brandRef: brandRefOrigin,
    } = value
    const {
      customerRef: oldCustomerRefOrigin,
      orderStafferRef: oldOrderStafferRefOrigin,
      brandRef: oldBrandRefOrigin,
    } = oldValue


    const customerRef = customerRefOrigin || { }
    const orderStafferRef = orderStafferRefOrigin || { }
    const brandRef = brandRefOrigin || { }

    const customerRefRelated = (customerRefOrigin !== oldCustomerRefOrigin) ? {
      customerKey: customerRef.key,
      customerName: customerRef.name,
      customerAddress: customerRef.address,
      customerZip: customerRef.zip,
      customerPhone: customerRef.phone,
      deliveryNote: customerRef.deliveryNote,
      printPrice: customerRef.printPrice,

      customerGroupRef: customerRef.groupRef,
      customerGroup: customerRef.groupRef && customerRef.groupRef.key,

      salesRegionRef: customerRef.salesRegionRef,
      salesRegion: customerRef.salesRegionRef && customerRef.salesRegionRef.key,

      salesRepRef: customerRef.salesPersonRef,
      salesRepName: customerRef.salesPersonRef && customerRef.salesPersonRef.name,
      salesRepPhone: customerRef.salesPersonRef && customerRef.salesPersonRef.phone,
    } : { }
    const orderStafferRefRelated = (orderStafferRefOrigin !== oldOrderStafferRefOrigin) ? {
      orderStafferKey: orderStafferRef && orderStafferRef.key,
    } : { }
    const brandRefRelated = (brandRefOrigin !== oldBrandRefOrigin) ? {
      brandKey: brandRef && brandRef.key,
    } : { }

    return {
      ...value,
      ...customerRefRelated,
      ...orderStafferRefRelated,
      ...brandRefRelated,
    }
  }),

  withProps(({ value }) => {
    const { customerGroupRef } = value
    const { brandRefs = [] } = customerGroupRef || { }
    return {
      brandOptionsFilter: (options) => options.filter(opt => brandRefs.includes(opt._id)),
    }
  }),

  exposeProps([
    'value',
    'onChange',

    'brandOptionsFilter',
  ]),
)(HeadEditorView)

HeadEditor.displayName = 'HeadEditor'

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/HeadEditor/index.js